var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "repeat-option-set repeat-option-set--end" },
    [
      _c("span", { staticClass: "repeat-option-end__label" }, [
        _vm._v(_vm._s(_vm.$t("calendar", "End repeat")))
      ]),
      _vm._v(" "),
      _c("Multiselect", {
        staticClass: "repeat-option-end__end-type-select",
        attrs: {
          options: _vm.options,
          searchable: false,
          "allow-empty": false,
          title: _vm.$t("calendar", "Select to end repeat"),
          value: _vm.selectedOption,
          "track-by": "value",
          label: "label"
        },
        on: { select: _vm.changeEndType }
      }),
      _vm._v(" "),
      _vm.isUntil
        ? _c("DatePicker", {
            staticClass: "repeat-option-end__until",
            attrs: {
              min: _vm.minimumDate,
              date: _vm.until,
              "is-all-day": true
            },
            on: { change: _vm.changeUntil }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isCount
        ? _c("input", {
            staticClass: "repeat-option-end__count",
            attrs: { type: "number", min: "1", max: "3500" },
            domProps: { value: _vm.count },
            on: { input: _vm.changeCount }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isCount
        ? _c("span", { staticClass: "repeat-option-end__count" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.occurrencesLabel) + "\n\t")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }